import { render, staticRenderFns } from "./CrearServicio.vue?vue&type=template&id=1289cd64&"
import script from "./CrearServicio.vue?vue&type=script&lang=js&"
export * from "./CrearServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports